export const GA_MEASUREMENT_ID = 'G-MLLGW6M2YE';

type AnalyticsParamValue = string | number | boolean | null | undefined;
type AnalyticsParams = Record<string, AnalyticsParamValue>;

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

export const sendPageView = (path: string) => {
  if (typeof window === 'undefined' || !window.gtag) {
    return;
  }

  window.gtag('event', 'page_view', {
    page_path: path,
    page_location: `${window.location.origin}${path}`,
    page_title: document.title,
    send_to: GA_MEASUREMENT_ID,
  });
};

export const sendAnalyticsEvent = (eventName: string, params: AnalyticsParams = {}) => {
  if (typeof window === 'undefined' || !window.gtag) {
    return;
  }

  const sanitizedParams = Object.fromEntries(
    Object.entries(params).filter(([, value]) => value !== undefined),
  );

  window.gtag('event', eventName, sanitizedParams);
};